import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import biMiddleware from 'shared/bi/bi-middleware';
import biHandlers from 'widget/redux/bi-middleware/bi-handlers';
import rootReducer from './root-reducer';


export default function configureStore(initialState = {}) {
  // Compose final middleware and use devtools extension in debug environment
  const middlewares = [
    thunk,
    biMiddleware(biHandlers),
  ];

  if (__DEBUG__) {
    const reduxLogger = require('redux-logger').createLogger({
      collapsed: true,
      diff: true,
    });
    middlewares.push(reduxLogger);
  }

  const middleware = composeWithDevTools(applyMiddleware(...middlewares));

  // Create final store and subscribe router in debug env ie. for devtools
  const store = middleware(createStore)(rootReducer, initialState);

  if (module.hot) {
    module.hot.accept('./root-reducer', () => {
      const nextRootReducer = require('./root-reducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/widget/redux/configure-store.js